import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import { mapData } from '../../../../product/common/components'
import Popup from '../../organisms/Popup'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import BuynowContext from '../../../../product/context/buynow/buynowContext'

const EditCertificateModal = (props) => {
    const { updateCertificate, responseStatus } = useContext(BuynowContext)

    const {
        open,
        product,
        handleClose,
        onSuccess,
        disable = false,
        winnerName = '',
        fontSize = '240',
        cstmModalClass = 'editCertModal',
        size = 'sm',
        modaltitle = 'Edit Certificate',
        submitLabel = 'Submit',
    } = props

    const [submitDisabled, setSubmitDisabled] = useState(false)

    const validationArray = Yup.object({
        font: Yup.number()
            .integer('Should be integer only')
            .min(1)
            .max(240, 'Maximum font size is 240')
            .required('Required!'),
        winner_name: Yup.string().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            winner_name: winnerName,
            font: fontSize,
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (!product) {
                return
            }
            setSubmitDisabled(true)
            updateCertificate({
                upload_certificate_images: product.upload_certificate_images,
                project_id: product.project_id,
                common_invoice: product.common_invoice,
                font_size: parseInt(values.font),
                winner_name: values.winner_name,
                qty: product.totalQty,
            })
        },
    })

    const resetForm = () => {
        formik.setFieldValue('winner_name', winnerName, false)
        formik.setFieldValue('font', fontSize, false)
    }

    const closeModal = () => {
        resetForm()
        if (handleClose) {
            handleClose()
        }
    }

    useEffect(() => {
        if (open) {
            resetForm()
        }
    }, [open, winnerName, fontSize])

    useEffect(() => {
        if (responseStatus && responseStatus.status === 'success') {
            setSubmitDisabled(false)
            resetForm()
            if (onSuccess) {
                onSuccess()
            }
            if (handleClose) {
                handleClose()
            }
        }
    }, [responseStatus])

    const ownerData = [
        {
            label: 'Winner Name',
            name: 'winner_name',
            placeholder: 'Enter Winner name',
            class: 'col-12',
            formik: formik,
            type: 'text',
            upperLabel: true,
        },
        {
            label: 'Font Size',
            name: 'font',
            placeholder: 'Enter Font Size',
            class: 'col-12',
            formik: formik,
            type: 'number',
            upperLabel: true,
        },
    ]

    return (
        <Popup
            open={open}
            cstmModalClass={cstmModalClass}
            size={size}
            handleClose={closeModal}
            modaltitle={modaltitle}
        >
            <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                <div className="row">{Object.values(mapData(ownerData))}</div>
                <div className="row">
                    <div className="col-12">
                        <PrimaryButton
                            btnSize="large"
                            type="submit"
                            label={submitLabel}
                            disabled={disable || submitDisabled}
                        />
                    </div>
                </div>
            </form>
        </Popup>
    )
}

EditCertificateModal.propTypes = {
    open: PropTypes.bool,
    product: PropTypes.shape({
        upload_certificate_images: PropTypes.any,
        project_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        common_invoice: PropTypes.any,
        totalQty: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    handleClose: PropTypes.func,
    onSuccess: PropTypes.func,
    disable: PropTypes.bool,
    winnerName: PropTypes.string,
    fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    cstmModalClass: PropTypes.string,
    size: PropTypes.string,
    modaltitle: PropTypes.string,
    submitLabel: PropTypes.string,
}

export default EditCertificateModal
